import ActivityCard from 'components/ActivityCard';
import BleedingCards from 'components/BleedingCards';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ActivityCards: FunctionComponent<Props> = ({
    className = '',
    items = [],
    testId = TEST_ID
}) => (
    <BleedingCards className={`${className} ${styles.activityCards}`} testId={testId}>
        {items.map(({ date, items }, index: number) => (
            <ActivityCard date={date} items={items} key={index} />
        ))}
    </BleedingCards>
);

export default ActivityCards;
